import React from 'react';
import Typography from '../Text/Typography';
import Colors from '../Colors/Colors';
import './Tag.css';

interface TagProps {
  children: React.ReactNode;
  className?: string;
}

const Tag: React.FC<TagProps> = ({ children, className = '' }) => {
  return (
    <span className={`tag ${className}`}>
      <Colors variant="black">
        <Typography variant="body-small-bold">
          {children}
        </Typography>
      </Colors>
    </span>
  );
};

export default Tag; 